module.exports = __webpack_public_path__ + "img/abo1.c0f613fa.jpg";